import { Container, Stack, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { fetchstockReportCitylist } from "src/utils/common";
import Products from "../Products/index";
import { CityStockProvider, useCityStockReport } from "./CityStockContext";

export default function Index() {
  const realUser = JSON.parse(localStorage.getItem("userData"));
  const { selectedCity, setSelectedCity } = useCityStockReport();
  const [citylist, setCityList] = useState([]);

  useEffect(() => {
    (async () => {
      const list = await fetchstockReportCitylist();
      setCityList(list || []);
    })();
  }, []);

  const cityUser = useMemo(() => {
    if (!selectedCity) return null;
    return {
      ...realUser,
      city_id: selectedCity.city_id,
      city_name: selectedCity.city_name,
      u_type: 1,
      p_user_id: 0
    };
  }, [selectedCity, realUser]);

  const handleCityChange = (option) => {
    if (!option) {
      setSelectedCity(null);
      return;
    }
    const city = citylist.find((c) => c.city_id === option.value);
    if (city) setSelectedCity(city);
  };

  return (
    <Container>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" gutterBottom sx={{ mb: 0 }}>
            City Stock Report
          </Typography>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography>Select City:</Typography>
            <div style={{ width: 300 }}>
              <Select
                placeholder="Select City"
                value={
                  selectedCity
                    ? { value: selectedCity.city_id, label: selectedCity.city_name }
                    : null
                }
                onChange={handleCityChange}
                options={citylist.map((city) => ({
                  label: city.city_name,
                  value: city.city_id
                }))}
              />
            </div>
          </Stack>
        </Stack>
        {cityUser && (
          <CityStockProvider cityUser={cityUser} realUser={realUser}>
            <Products />
          </CityStockProvider>
        )}
      </Stack>
    </Container>
  );
}
